/*
 * @Date: 2022-02-21 15:52:57
 * @LastEditors: wangyu
 * @LastEditTime: 2022-03-31 15:48:29
 * @FilePath: \qrcode\src\i18n\lang\cn.js
 */
'use strict'

exports.__esModule = true
exports.default = void 0
const message = {
  JumpMarket: {
    TItle: 'NoesisHome乐图 APP',
    simpleness: '简单便捷操控、贴心周到服务、',
    oneKey: '一键开启智能生活',
    btn: 'Download App'
  }
}
exports.default = message
